<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
  <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <Form ref="promotionForm" @submit="addPromotion" :validation-schema="promotionSchema">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10" >
                  Nom <span class="text-danger">*</span>
                </label>
                <Field name="nomPromo" type="text" 
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le nom"/>
                <ErrorMessage name="nomPromo" class="text-danger"/>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Taux
                </label>
                <Field name="taux" type="text" 
                  class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le taux"/>
                <ErrorMessage name="taux" class="text-danger"/>
              </div>
            </div>
            <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Date de début
                  </label>
                  <Field name="dateDebut" type="date" :value="getCurrentDate()"
                  class="form-control shadow-none fs-md-15 text-black"/>
                  <ErrorMessage name="dateDebut" class="text-danger"/>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Date de fin
                  </label>
                  <Field name="dateFin" type="date" :value="getCurrentDate()"
                  class="form-control shadow-none fs-md-15 text-black"/>
                  <ErrorMessage name="dateFin" class="text-danger"/>
                </div>
              </div>
        <div class="col-md-12">
          <div class="d-flex align-items-center ">
            <button
              class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
              type="submit"
            >
                Ajouter une promotion
            </button>
            <router-link to="/liste-promotions" 
                class=" btn btn-danger transition border-0 lh-1 fw-medium"><i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative"></span>Annuler</router-link>
          </div>
        </div>
      </div>
    </Form>
  </div>
</div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import { error, success } from '../../../utils/utils';
import { useRouter } from "vue-router";
import ApiService from '../../../services/ApiService';
import { Promotion } from '../../../models/Promotion';
import * as Yup from 'yup';


export default defineComponent({
    name: "AddPromotion",
    components: {
    Form,
    Field,
    ErrorMessage,
  },
  setup: () => {
    const promotionSchema = Yup.object().shape({
      nomPromo: Yup.string().required('Le nom est obligatoire'),
      taux: Yup.number().typeError('Veuillez entrer des chiffres').required('Le taux est obligatoire'),
      dateDebut: Yup.date().typeError("Entrer une date valide").required('La date de début est obligatoire'),
      dateFin: Yup.date().typeError("Entrer une date valide")
        .required('La date de fin est obligatoire')
        .min(Yup.ref('dateDebut'), 'La date de fin ne peut pas être antérieure à la date de début')
    });

    const promotionForm = ref<Promotion | null>(null);
    const router = useRouter();

    const getCurrentDate = () => {
          const today = new Date();
          const day = String(today.getDate()).padStart(2, '0');
          const month = String(today.getMonth() + 1).padStart(2, '0');
          const year = today.getFullYear();
          return `${year}-${month}-${day}`;
      }

    const addPromotion = async (values, {resetForm}) => {
      // values['dateDebut'] = new Date(values['dateDebut']).toISOString();
      // values['dateFin'] = new Date(values['dateFin']).toISOString();
      console.log('donees envoyees', values)
      ApiService.post("/promotions",values)
        .then(({ data }) => {
          if(data.code == 201) { 
            success(data.message);
            resetForm();
            router.push({ name: "ListePromotionPage" });
          }
        }).catch(({ response }) => {
          error(response.data.message);
        });
    };

    return { promotionSchema, addPromotion, promotionForm, getCurrentDate};
  },
});
</script>